import { isContentFragment } from './content-fragment';
export function isContentContainerWithContent(item) {
    return (isContentFragment(item) &&
        Object.keys(item.fields).length > 0);
}
//# sourceMappingURL=content-container.js.map